import EndSecreemMetrics from './EndSecreemMetrics';

export default EndSecreemMetrics;
